<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Срочная сборка
    </template>

    <p>Выбирая опцию «Срочная сборка», ваш заказ обрабатывается в приоритетном порядке. В периоды высокой загрузки склада это позволяет сократить время ожидания и&nbsp;получить товары быстрее остальных клиентов.</p>

    <template #action>
      <BasicButton color="green" title="Понятно" @click="close" />
    </template>
  </CustomModalWindow>
</template>
